<template>
  <v-edit-dialog
    large
    @save="save"
    @open="open"
    save-text="SALVAR"
    cancel-text="CANCELAR"
    :return-value.sync="editText">
    <px-situacao-requisicao-icon :situacao="requisicao.situacao"/>
    <px-span-tooltip top :text="identificador" :tooltip="requisicao.identificador"/>
    <template v-slot:input>
      <px-edit-identificador v-model="editText"/>
    </template>
  </v-edit-dialog>
</template>

<script>
import Vue from 'vue';
import RequisicaoService from '../requisicoes-service';

export default {
  props: {
    requisicao: Object,
    saveFunction: {
      type: Function,
      default: RequisicaoService.updateIdentifier,
    },
  },
  data() {
    return {
      editText: null,
    };
  },
  computed: {
    identificador() {
      return Vue.filter('truncate')(this.requisicao.identificador, 10);
    },
  },
  methods: {
    buildRequisicao() {
      return {
        id: this.requisicao.id,
        identificador: this.editText,
      };
    },
    saveIdentifier() {
      this.saveFunction(this.requisicao.id, this.buildRequisicao())
        .then(() => {
          this.$toast('Identificador atualizado', { color: 'success' });
          this.$emit('update');
        });
    },
    save() {
      this.saveIdentifier();
    },
    open() {
      this.editText = this.requisicao.identificador;
    },
  },
};
</script>
